import enumBase from './EnumBase';

export default class EnvelopeState extends enumBase {
  static DRAFT = 'draft';

  static IN_TRANSIT = 'in-transit';

  static EXPIRED = 'expired';

  static CANCELLED = 'cancelled';

  static PROCESSING = 'processing';

  static COMPLETED = 'completed';

  static HALTED = 'halted';

  static values = [
    this.DRAFT,
    this.IN_TRANSIT,
    this.EXPIRED,
    this.CANCELLED,
    this.PROCESSING,
    this.COMPLETED,
    this.HALTED,
  ];

  /**
   * Envelope is opened for be signed only the state is in-transit
   * @param string value
   * @returns boolean
   */
  static isOpened(value) {
    return value === this.IN_TRANSIT;
  }

  static isClosed(value) {
    return !this.isOpened(value);
  }

  static getAllSentStates() {
    return this.values.filter((item) => item.value !== this.DRAFT);
  }

  static getAllSentStatesTranslated(i18n) {
    return this.values
      .filter((item) => item.value !== this.DRAFT)
      .map((item) => ({
        value: item,
        label: i18n.t(`signaturesList.envelopeStates.${item}`) || item,
      }));
  }

  static getText(value, i18n) {
    return i18n.t(`signaturesList.envelopeStates.${value}`) || value;
  }

  static getDescription(value, i18n) {
    return i18n.t(`signaturesList.envelopeDescriptions.${value}`) || '';
  }
}
